/**
 * Analytics Library
 * Library interface to interact with Google Analytics library loaded elsewhere
 * version 2.2.0
 * 
 * Using Semantic Versioning, please update accordingly to keep files in sync across code bases
 * 
 * Given a version number MAJOR.MINOR.PATCH, increment the:
 *  1. MAJOR version when you implement a full re-build of the architecture,
 *  2. MINOR version when you add functionality, and
 *  3. PATCH version when you implement bug fixes or make small  tweaks to current functionality.
 */
define('analytics',[
    "jquery",
    "logging"
], function ($, logging) {
    "use strict";

    var _ModuleName = "Analytics";
    var _config = {
        enabled: true,
        account: "UA-6605286-6",
        customGAObjectName: "", // set this if analytics is handled by 3rd party plug-in using custom object
        customTrackerName: "", // set this if analytics is handled by 3rd party plug-in using custom tracker name
        scriptUrl: "https://www.google-analytics.com/analytics.js",
        types: {
            dimension: "dimension",
            metric: "metric",
            pageview: "pageview",
            create: "create",
            command: "command",
            event: "event"
        },
        maxReadyChecks: 10 // Checks every 1s
    }
    var _queue = [];

    function init() {
        // Make sure analytics is enabled
        if(!_config.enabled) return;

        ;

        _checkAnalyticsReady();
    }

    function SetDimension(index, value) {
        // Make sure analytics is enabled
        if(!_config.enabled) return;

        if (_analyticsIsLoaded() && value) {
            ;
            var ga = _ga();
            ga(_tracker() + 'set', 'dimension' + index, value);
        } else {
            ;
            _queue.push({
                type: _config.types.dimension,
                index: index,
                value: value
            });
        }
    }

    function SetMetric(index, value) {
        // Make sure analytics is enabled
        if(!_config.enabled) return;

        if (_analyticsIsLoaded() && value) {
            ;
            var ga = _ga();
            ga(_tracker() + 'set', 'metric' + index, value);
        } else {
            ;
            _queue.push({
                type: _config.types.metric,
                index: index,
                value: value
            });
        }
    }

    function FireEvent(category, action, label, nonInteraction) {
        if(!_config.enabled) return;

        if (_analyticsIsLoaded()) {
            ;
            var ga = _ga();
            ga(_tracker() + 'send', 'event', category, action, label, {
                nonInteraction: nonInteraction
            });
        } else {
            ;
            _queue.push({
                type: _config.types.event,
                category: category,
                action: action,
                label: label,
                nonInteraction: nonInteraction
            });
        }
    }

    function RunCustomCommand(name, command) {
        // Make sure analytics is enabled
        if(!_config.enabled) return;

        // If a proper command wasn't passed in, just return
        if(typeof command !== 'function') return;

        if (_analyticsIsLoaded()) {
            ;
            
            // run the command
            command();
        } else {
            ;
            _queue.push({
                type: _config.types.command,
                name: name,
                command: command
            })
        }
    }

    function _processQueue() {
        if (_analyticsIsLoaded() && _queue.length > 0) {
            ;
            var ga = _ga();
            while (_queue.length > 0) {
                var task = _queue.shift();

                // DIMENSION
                if (task.type == _config.types.dimension) {
                    ;
                    ga(_tracker() + 'set', 'dimension' + task.index, task.value);

                // METRIC
                } else if (task.type == _config.types.metric) {
                    ;
                    ga(_tracker() + 'set', 'metric' + task.index, task.value);

                // COMMAND
                } else if (task.type == _config.types.command) {
                    ;
                    task.command();
                
                // EVENT
                } else if (task.type == _config.types.event) {
                    ;
                    ga(_tracker() + 'send', 'event', task.category, task.action, task.label, {
                        nonInteraction: task.nonInteraction
                    });
                }

            }
        }
    }

    function _checkAnalyticsReady() {
        if(_analyticsIsLoaded()) {
            ;
            _processQueue();
        } else {
            if (_config.maxReadyChecks > 0) {
                setTimeout(_checkAnalyticsReady, 1e3);
                _config.maxReadyChecks--;
                ;
            }
        }
    }

    function _analyticsIsLoaded() {
        var ga = _ga();
        return ga && ga.create;
    }

    function _ga() {
        if (_config.customGAObjectName && window[_config.customGAObjectName]) {
            return window[_config.customGAObjectName];
        } else if (window.ga) {
            return window.ga;
        }
        return { };
    }

    function _tracker() {
        return (_config.customTrackerName ? _config.customTrackerName + "." : "");
    }

    return {
        init: init,
        SetDimension: SetDimension,
        SetMetric: SetMetric,
        FireEvent: FireEvent,
        RunCustomCommand: RunCustomCommand
    }
});
